import { FunctionComponent, useState } from 'react';
import TextField from '@mui/material/TextField';
import type { TextFieldProps } from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import { PasswordAdornment } from '../_components/PasswordAdornment/PasswordAdornment';
import { getPasswordInputProps, getPasswordInputType, maskedInputStyle } from '../_helpers/passwordInput';

// A hidden password is a text input masked with CSS, see `passwordInput.ts`.
const MaskedTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'maskText',
})<{ maskText: boolean }>(({ maskText }) => (maskText ? maskedInputStyle : {}));

export const PasswordField: FunctionComponent<TextFieldProps> = (props) => {
  const { disabled } = props;

  const [showPassword, setShowPassword] = useState(false);

  // Hidden again when the field flips between edit and view mode, see TextFieldControl.
  const [wasDisabled, setWasDisabled] = useState(disabled);
  if (wasDisabled !== disabled) {
    setWasDisabled(disabled);
    setShowPassword(false);
  }

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <MaskedTextField
      {...props}
      type={getPasswordInputType(showPassword)}
      maskText={!showPassword}
      slotProps={{
        htmlInput: getPasswordInputProps(showPassword),
        ...(!disabled && {
          input: {
            endAdornment: (
              <PasswordAdornment
                isPasswordVisible={showPassword}
                togglePasswordVisibility={handleClickShowPassword}
              />
            ),
          },
        }),
      }}
    />
  );
};
